import { v4 } from "uuid";
import layoutEngine from "../libraries/layoutEngine";
import ProjectManager from "./ProjectManager";

export default class FeatureRenderer {
  constructor(engine) {
    this.engine = engine;
    this.ctx = this.engine.ctx;
    this.userName = null;
    this.fileHandle = null;
    this.scene = {
      userName: this.userName,
      bug: [],
      improvement: [],
      query: [],
    };
    this.sceneByCell = {};
    this.activeTab = "bug";
    this.isDotMode = false;
    this.rectangleMode = false;
    this.isEditable = false;
    this.color = "red";
    this.seeAllDots = false;
    this.allDetails = [];
    this.selectedQuery = null;
    this.isDrawing = false;
    this.rectangleStartPoint = null;
    this.rectangleEndPoint = null;
    this.currentRectangle = null;
    this.lastSearchTerm = "";
  }
  // update username
  updateUsername(userName) {
    this.userName = userName;
  }

  // see all bugs details in a single click
  visibleAllDetails() {
    const activeCell = this.getCurrentCell();
    this.allDetails = this.scene[this.activeTab] || [];

    window.dispatchEvent(
      new CustomEvent("sceneUpdated", {
        detail: {
          allDetails: this.allDetails,
          scene: this.scene,
          selectedQuery: this.selectedQuery,
          activeTab: this.activeTab,
          isDotMode: this.isDotMode,
          rectangleMode: this.rectangleMode,
          seeAllDots: this.seeAllDots,
          isEditable: this.isEditable,
          color: this.color,
          activeCell: activeCell,
        },
      })
    );

    // console.log(`All ${this.activeTab} details:`, this.allDetails);
  }
  // get current cell
  getCurrentCell() {
    const Cellname = ProjectManager?.getSelectedCell?.();
    if (Cellname) return Cellname;
    const fallbackCellname = layoutEngine?.getActiveCellName?.();
    return fallbackCellname ?? null;
  }
  // uploaded data in json
  uploadJSON(importedData) {
    const activeCell = this.getCurrentCell();
    if (activeCell === null) {
      alert("Please choose cell for update the data");
      return false;
    }
    this.scene = importedData;
    this.sceneByCellUpdate(activeCell);
    this.loadSceneForCell(activeCell);
  }
  // Load scene for a specific cell
  loadSceneForCell(cellName) {
    if (!cellName) {
      this.scene = {
        userName: this.userName,

        bug: [],
        improvement: [],
        query: [],
      };
      this.selectedQuery = null;
      this.drawData();
      return;
    }

    // Load existing scene or create new one
    if (this.sceneByCell[cellName]) {
      this.scene = structuredClone(this.sceneByCell[cellName]);
    } else {
      this.scene = {
        userName: this.userName,
        bug: [],
        improvement: [],
        query: [],
      };
    }

    // Update selected query for this cell
    this.selectedQuery = this.scene[this.activeTab]?.at(-1) || null;
    this.isDotMode = false;
    this.rectangleMode = false;
    this.isDrawing = false;
    this.rectangleStartPoint = null;
    this.rectangleEndPoint = null;
    this.currentRectangle = null;

    //dispatch event to ui update
    window.dispatchEvent(
      new CustomEvent("sceneUpdated", {
        detail: {
          scene: this.scene,
          selectedQuery: this.selectedQuery,
          activeTab: this.activeTab,
          isDotMode: this.isDotMode,
          rectangleMode: this.rectangleMode,
          seeAllDots: this.seeAllDots,
          isEditable: this.isEditable,
          color: this.color,
          activeCell: cellName,
        },
      })
    );
    this.drawData();
  }

  // change active tab
  changeActiveTab(tab) {
    this.activeTab = tab;
    this.color =
      this.activeTab === "bug"
        ? "red"
        : this.activeTab === "improvement"
        ? "blue"
        : "green";
    this.selectedQuery = this.scene[this.activeTab]?.at(-1) || null;
    this.isDotMode = false;
    this.rectangleMode = false;
    this.isDrawing = false;
    this.rectangleStartPoint = null;
    this.rectangleEndPoint = null;
    this.currentRectangle = null;

    // console.log(this.color)
  }

  getWorldCoords(e) {
    const rect = this.engine.canvas.getBoundingClientRect();
    const x = (e.clientX - rect.left - this.engine.offsetX) / this.engine.scale;
    const y = (e.clientY - rect.top - this.engine.offsetY) / this.engine.scale;
    return { x, y };
  }

  // gird size logic according to spacing
  snapToGrid(value) {
    const spacing = 1;
    return Math.round(value / spacing) * spacing;
  }

  // converting logic for coordiantes to nearest point
  snapPointToGrid(point) {
    return {
      x: this.snapToGrid(point.x),
      y: this.snapToGrid(point.y),
    };
  }

  // toggle dot mode
  toggleIsDotMode() {
    const activeCell = this.getCurrentCell();
    if (activeCell === null) {
      alert("Please select or add cell before drawing");
      return false;
    }
    this.isDotMode = !this.isDotMode;
    this.seeAllDots = false;
    return true;
    // console.log("Dot mode is now:", this.isDotMode);
  }

  // toggle rectangle mode
  toggleIsRectangleMode() {
    if (this.selectedQuery === null) {
      alert("Please select a query to add rectangle to.");
      return;
    }
    this.rectangleMode = !this.rectangleMode;
    this.isDotMode = false;
    // console.log("Rectangle mode is now:", this.rectangleMode);
  }

  //toggle editable mode
  toggleIsEditable() {
    this.isEditable = !this.isEditable;
    // console.log("Editable mode is now:", this.isEditable);
  }

  // toggle see all dots
  toggleSeeAllDots() {
    this.selectedQuery = null;
    this.seeAllDots = !this.seeAllDots;
    if (this.seeAllDots) {
      this.visibleAllDetails();
    }
    this.drawData();
  }

  //  push data on scene by cell name with deep clone
  sceneByCellUpdate(activeCell) {
    if (activeCell) {
      // Use structuredClone to avoid reference issues
      this.sceneByCell[activeCell] = structuredClone(this.scene);
      // console.log(activeCell, this.sceneByCell);
    } else {
      alert("No cell selected to save data");
      return;
    }
  }

  //clear canvas
  clearCanvas() {}
  // emit data to ui
  emitSceneUpdate() {
    const activeCell = this.getCurrentCell();
    this.loadSceneForCell(activeCell);
  }
  // on canvas click execution
  handleCommunicationMouseDown(e) {
    // if cell is not selected / added
    const activeCell = this.getCurrentCell();
    if (!activeCell) {
      this.isDotMode = false;
      this.rectangleMode = false;
      this.isDrawing = false;
      window.dispatchEvent(
        new CustomEvent("sceneUpdated", {
          detail: {
            scene: this.scene,
            selectedQuery: this.selectedQuery,
            activeTab: this.activeTab,
            isDotMode: this.isDotMode,
            rectangleMode: this.rectangleMode,
            seeAllDots: this.seeAllDots,
            isEditable: this.isEditable,
            color: this.color,
            activeCell: activeCell,
          },
        })
      );
      return alert("Please select or add cell before drawing");
    }
    // after selecting / adding cell
    const coordiantes = this.getWorldCoords(e);
    const snappedCoordinates = this.snapPointToGrid(coordiantes);

    // Created new bug / improvement / query by clicking on canvas
    if (this.isDotMode) {
      this.createBug(snappedCoordinates.x, snappedCoordinates.y);
      this.drawData();
      return;
    }

    // Start drawing rectangle on canvas
    if (this.rectangleMode && this.selectedQuery !== null) {
      if (!this.isDrawing) {
        this.isDrawing = true;
        this.rectangleStartPoint = snappedCoordinates;
      }
      return;
    }
  }

  // on mouse up
  handleCommunicationMouseUp(e) {
    if (this.rectangleMode && this.isDrawing && this.selectedQuery) {
      const coordinates = this.getWorldCoords(e);
      const snappedCoordinates = this.snapPointToGrid(coordinates);

      this.rectangleEndPoint = snappedCoordinates;

      // Calculate rectangle bounds
      const x1 = Math.min(this.rectangleStartPoint.x, this.rectangleEndPoint.x);
      const y1 = Math.min(this.rectangleStartPoint.y, this.rectangleEndPoint.y);
      const x2 = Math.max(this.rectangleStartPoint.x, this.rectangleEndPoint.x);
      const y2 = Math.max(this.rectangleStartPoint.y, this.rectangleEndPoint.y);

     
      // Only create rectangle if it meets minimum size
      const minSize = 1;
      if (Math.abs(x2 - x1) >= minSize && Math.abs(y2 - y1) >= minSize) {
        this.createRectangle(x1, y1, x2, y2);
      }
  
      // Reset drawing state
      this.isDrawing = false;
      this.rectangleStartPoint = null;
      this.rectangleEndPoint = null;
      this.currentRectangle = null;

      this.drawData();
    }
  }

  // on mouse move
  handleCommunicationMouseMove(e) {
    if (this.rectangleMode && this.isDrawing && this.rectangleStartPoint) {
      const coordinates = this.getWorldCoords(e);
      const snappedCoordinates = this.snapPointToGrid(coordinates);

      // Update end point for preview
      this.rectangleEndPoint = snappedCoordinates;

      // Create current rectangle for preview
      this.currentRectangle = {
        x1: Math.min(this.rectangleStartPoint.x, this.rectangleEndPoint.x),
        y1: Math.min(this.rectangleStartPoint.y, this.rectangleEndPoint.y),
        x2: Math.max(this.rectangleStartPoint.x, this.rectangleEndPoint.x),
        y2: Math.max(this.rectangleStartPoint.y, this.rectangleEndPoint.y),
      };

      // Redraw to show preview
      this.drawData();
    }
  }

  // for creating new bug / improvement / query
  createBug(x, y) {
    const activeCell = this.getCurrentCell();
    const now = new Date();
    const date = now.toLocaleDateString("en-US");
    const time = now.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    const newId = v4();
    const currentTabData = this.scene[this.activeTab] || [];
    const newBug = {
      id: newId,
      number: currentTabData.length + 1,
      username: this.userName,
      date,
      time,
      is_resolved: false,
      points: { x: x, y: y },
      rectangle: [],
      description: [],
    };
    currentTabData.push(newBug);
    this.selectedQuery = currentTabData.at(-1);
    this.scene[this.activeTab] = currentTabData;
    // Save to cell immediately
    this.sceneByCellUpdate(activeCell);
    this.isDotMode = false;
    window.dispatchEvent(
      new CustomEvent("sceneUpdated", {
        detail: {
          scene: this.scene,
          selectedQuery: this.selectedQuery,
          activeTab: this.activeTab,
          isDotMode: this.isDotMode,
          rectangleMode: this.rectangleMode,
          seeAllDots: this.seeAllDots,
          isEditable: this.isEditable,
          color: this.color,
          activeCell: activeCell,
        },
      })
    );
  }

  // New method to create and store rectangle data
  createRectangle(x1, y1, x2, y2) {
    const activeCell = this.getCurrentCell();
    if (this.selectedQuery === null || !this.rectangleMode) {
      alert("Please select a query to add rectangle to.");
      return;
    }

    const newRectangle = {
      id: v4(), // Generate unique ID
      bbox: {
        xll: x1, // x lower left
        yll: y1, // y lower left
        xur: x2, // x upper right
        yur: y2, // y upper right
      },
    };

    // Add rectangle to selected query
    this.selectedQuery.rectangle.push(newRectangle);
    this.sceneByCellUpdate(activeCell);

    // Dispatch event to update UI
    window.dispatchEvent(
      new CustomEvent("sceneUpdated", {
        detail: {
          scene: this.scene,
          selectedQuery: this.selectedQuery,
          activeTab: this.activeTab,
          isDotMode: this.isDotMode,
          rectangleMode: this.rectangleMode,
          seeAllDots: this.seeAllDots,
          isEditable: this.isEditable,
          color: this.color,
          activeCell: this.getCurrentCell(),
        },
      })
    );
  }

  // set selected query
  setSelectedQuery(query) {
    this.selectedQuery = query;
    this.seeAllDots = false;
    this.rectangleMode = false;
    this.isEditable = false;
    this.drawData(); // Redraw to reflect the selected query
    // Focus the view on the selected query
    this.focusSelectedQuery(500);
  }
  // delete rectangle from selected query
  deleteRectangle() {
    const activeCell = this.getCurrentCell();
    if (!this.selectedQuery) {
      alert("No query selected to delete rectangle from");
      return false;
    }
    if (
      !this.selectedQuery.rectangle ||
      this.selectedQuery.rectangle.length === 0
    ) {
      alert("No rectangles to delete");
      return false;
    }
    this.selectedQuery.rectangle.pop();
    this.sceneByCellUpdate(activeCell);
    this.drawData();
    window.dispatchEvent(
      new CustomEvent("sceneUpdated", {
        detail: {
          scene: this.scene,
          selectedQuery: this.selectedQuery,
          activeTab: this.activeTab,
          isDotMode: this.isDotMode,
          rectangleMode: this.rectangleMode,
          seeAllDots: this.seeAllDots,
          isEditable: this.isEditable,
          color: this.color,
          activeCell: activeCell,
        },
      })
    );
  }
  //  handle add comment in active tab and selected query
  addComment(comment, tab, queryId) {
    const query = this.scene[tab]?.find((q) => q.id === queryId);
    if (query) {
      query.description.push(comment);
      this.sceneByCellUpdate(this.getCurrentCell());

      // Dispatch event to update UI
      window.dispatchEvent(
        new CustomEvent("sceneUpdated", {
          detail: {
            scene: this.scene,
            selectedQuery: this.selectedQuery,
            activeTab: this.activeTab,
            isDotMode: this.isDotMode,
            rectangleMode: this.rectangleMode,
            seeAllDots: this.seeAllDots,
            isEditable: this.isEditable,
            color: this.color,
            activeCell: this.getCurrentCell(),
          },
        })
      );
      return true;
    }
    return false;
  }

  //  handle edit comment in active tab and selected query
  addEditedComment(updatedDescription, tab, queryId) {
    const query = this.scene[tab]?.find((q) => q.id === queryId);
    if (query) {
      query.description = updatedDescription;
      this.sceneByCellUpdate(this.getCurrentCell());

      // Dispatch event to update UI
      window.dispatchEvent(
        new CustomEvent("sceneUpdated", {
          detail: {
            scene: this.scene,
            selectedQuery: this.selectedQuery,
            activeTab: this.activeTab,
            isDotMode: this.isDotMode,
            rectangleMode: this.rectangleMode,
            seeAllDots: this.seeAllDots,
            isEditable: this.isEditable,
            color: this.color,
            activeCell: this.getCurrentCell(),
          },
        })
      );
      return true;
    }
    return false;
  }

  //  delete selected query
  deleteSelectedQuery() {
    if (!this.selectedQuery) return false;

    const currentTabData = this.scene[this.activeTab] || [];
    const queryIndex = currentTabData.findIndex(
      (q) => q.id === this.selectedQuery.id
    );

    if (queryIndex !== -1) {
      currentTabData.splice(queryIndex, 1);
      // Rearrange the numbers to maintain sequential order
      currentTabData.forEach((item, index) => {
        item.number = index + 1;
      });
      this.scene[this.activeTab] = currentTabData;
      this.selectedQuery = this.scene[this.activeTab]?.at(-1) || null;

      // Save to cell after deletion
      this.sceneByCellUpdate(this.getCurrentCell());
      this.drawData();

      // Dispatch event to update UI
      window.dispatchEvent(
        new CustomEvent("sceneUpdated", {
          detail: {
            scene: this.scene,
            selectedQuery: this.selectedQuery,
            activeTab: this.activeTab,
            isDotMode: this.isDotMode,
            rectangleMode: this.rectangleMode,
            seeAllDots: this.seeAllDots,
            isEditable: this.isEditable,
            color: this.color,
            activeCell: this.getCurrentCell(),
          },
        })
      );
      return true;
    }

    return false;
  }

  //  mark selected query as resolved
  markSelectedQueryAsResolved(selectedQuery) {
    if (!this.selectedQuery) {
      alert("No query selected to mark as resolved");
      return false;
    }
    const currentTabData = this.scene[this.activeTab] || [];
    const matchedQuery = currentTabData.findIndex(
      (item) => item.id === selectedQuery.id
    );
    if (matchedQuery !== -1) {
      currentTabData[matchedQuery] = {
        ...currentTabData[matchedQuery],
        is_resolved: !currentTabData[matchedQuery].is_resolved,
      };

      // Save to cell after marking resolved
      this.sceneByCellUpdate(this.getCurrentCell());

      // Dispatch event to update UI
      window.dispatchEvent(
        new CustomEvent("sceneUpdated", {
          detail: {
            scene: this.scene,
            selectedQuery: this.selectedQuery,
            activeTab: this.activeTab,
            isDotMode: this.isDotMode,
            rectangleMode: this.rectangleMode,
            seeAllDots: this.seeAllDots,
            isEditable: this.isEditable,
            color: this.color,
            activeCell: this.getCurrentCell(),
          },
        })
      );
      return true;
    }
    return false;
  }

  // search comments  in active tab
  searchComments(comment) {
    const term = (comment ?? "").toString().trim().toLowerCase();
    this.lastSearchTerm = term;

    const list = this.scene?.[this.activeTab] || [];

    const matches = (q) => {
      const desc = Array.isArray(q.description) ? q.description : [];
      return desc.some((d) => {
        const text =
          typeof d === "string"
            ? d
            : typeof d === "object" && d !== null
            ? d.text ?? d.message ?? d.comment ?? d.body ?? ""
            : "";
        return text.toString().toLowerCase().includes(term);
      });
    };

    const results = term ? list.filter(matches) : list;

    return results;
  }

  //  download data as JSON file (includes all cells)

  async handleDownloadJSON() {
    // Save current cell before download
    const activeCell = this.getCurrentCell();
    if (activeCell) {
      this.sceneByCellUpdate(activeCell);
    }

    const commentDetails = this.scene;
    if (
      commentDetails.bug.length === 0 &&
      commentDetails.improvement.length === 0 &&
      commentDetails.query.length === 0
    ) {
      return alert("No details are there");
    }

    const allDetails = structuredClone(commentDetails);
    const dataStr = JSON.stringify(allDetails, null, 4);
    const filename = `${activeCell}.cf`;

    try {
      if ("showSaveFilePicker" in window) {
        // ✅ Reset file handle if filename changes (switching cells)
        if (!this.fileHandle || this.fileHandle.name !== filename) {
          this.fileHandle = await window.showSaveFilePicker({
            suggestedName: filename,
            types: [
              {
                description: "Cell File",
                accept: { "application/json": [".cf"] },
              },
            ],
          });
        }

        // ✅ This overwrites existing file without renaming
        const writable = await this.fileHandle.createWritable();
        await writable.write(dataStr);
        await writable.close();

        alert("File saved successfully ✅");
      } else {
        // Fallback traditional download (mobile/unsupported browsers)
        const blob = new Blob([dataStr], { type: "application/json" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.click();
        URL.revokeObjectURL(url);
        alert("File downloaded ✅");
      }
    } catch (err) {
      if (err.name !== "AbortError") {
        console.error("Error saving file:", err);
        alert("Failed to save file ❌");
      }
    }
  }

  // drawing function for dot (circle) bug / improvement / query
  drawDot(x, y, radius) {
    // console.log("Drawing dot at:", x, y , radius);
    this.ctx.save();
    this.ctx.translate(this.engine.offsetX, this.engine.offsetY);
    this.ctx.scale(this.engine.scale, this.engine.scale);
    this.ctx.beginPath();
    this.ctx.arc(x, y, radius / this.engine.scale, 0, 2 * Math.PI);
    this.ctx.fillStyle = this.color;
    this.ctx.fill();
    this.ctx.restore();
  }

  drawRectangle(x1, y1, x2, y2) {
    this.ctx.save();
    this.ctx.translate(this.engine.offsetX, this.engine.offsetY);
    this.ctx.scale(this.engine.scale, this.engine.scale);
    this.ctx.beginPath();
    this.ctx.strokeStyle = this.color;
    this.ctx.lineWidth = 2 / this.engine.scale;
    this.ctx.strokeRect(x1, y1, x2 - x1, y2 - y1);
    this.ctx.restore();
  }

  // Draw preview rectangle while drawing
  drawPreviewRectangle() {
    if (this.currentRectangle && this.isDrawing) {
      this.ctx.save();
      this.ctx.translate(this.engine.offsetX, this.engine.offsetY);
      this.ctx.scale(this.engine.scale, this.engine.scale);
      this.ctx.beginPath();
      this.ctx.strokeStyle = this.color;
      this.ctx.lineWidth = 2 / this.engine.scale;
      this.ctx.setLineDash([1, 1]); // Dashed line for preview
      this.ctx.strokeRect(
        this.currentRectangle.x1,
        this.currentRectangle.y1,
        this.currentRectangle.x2 - this.currentRectangle.x1,
        this.currentRectangle.y2 - this.currentRectangle.y1
      );
      this.ctx.restore();
    }
  }
  drawData() {
    // Don't reload scene here - just draw what's in this.scene

    if (this.selectedQuery?.points) {
      // Draw the dot
      this.drawDot(this.selectedQuery.points.x, this.selectedQuery.points.y, 4);

      // Draw all rectangles for selected query
      if (
        this.selectedQuery.rectangle &&
        this.selectedQuery.rectangle.length > 0
      ) {
        this.selectedQuery.rectangle.forEach((rect) => {
          this.drawRectangle(
            rect.bbox.xll,
            rect.bbox.yll,
            rect.bbox.xur,
            rect.bbox.yur
          );
        });
      }

      // Draw preview rectangle while drawing
      this.drawPreviewRectangle();
    } else if (this.seeAllDots) {
      const allDots = this.scene[this.activeTab] || [];
      allDots.forEach((dot) => {
        if (dot.points) {
          this.drawDot(dot.points.x, dot.points.y, 4);

          // Also draw rectangles for all dots when seeing all
          if (dot.rectangle && dot.rectangle.length > 0) {
            dot.rectangle.forEach((rect) => {
              this.drawRectangle(
                rect.bbox.xll,
                rect.bbox.yll,
                rect.bbox.xur,
                rect.bbox.yur
              );
            });
          }
        }
      });
    }
  }
  smoothZoomToViolation(violation, duration = 500) {
    if (!violation?.location?.length) return false;

    const xs = violation.location.map((p) => p[0]);
    const ys = violation.location.map((p) => p[1]);
    const minX = Math.min(...xs);
    const maxX = Math.max(...xs);
    const minY = Math.min(...ys);
    const maxY = Math.max(...ys);

    const w = maxX - minX || 1;
    const h = maxY - minY || 1;

    const dpr = this.engine.dpr || window.devicePixelRatio || 1;
    const canvasWidth = this.engine.canvas.width / dpr;
    const canvasHeight = this.engine.canvas.height / dpr;

    const padding = 20;
    const scaleX = (canvasWidth - padding * 2) / w;
    const scaleY = (canvasHeight - padding * 2) / h;
    const minScale = this.engine.minScale ?? 0.01;
    const maxScale = this.engine.maxScale ?? 100;
    const targetScale = Math.min(
      maxScale,
      Math.max(minScale, Math.min(scaleX, scaleY))
    );

    const cx = (minX + maxX) / 2;
    const cy = (minY + maxY) / 2;
    const targetX = canvasWidth / 2 - cx * targetScale;
    const targetY = canvasHeight / 2 - cy * targetScale;

    const startScale = this.engine.scale;
    const startX = this.engine.offsetX;
    const startY = this.engine.offsetY;

    const startTime = performance.now();

    if (this._zoomRaf) cancelAnimationFrame(this._zoomRaf);
    const animate = (time) => {
      const progress = Math.min((time - startTime) / duration, 1);
      const t = 1 - Math.pow(1 - progress, 3);

      this.engine.scale = startScale + (targetScale - startScale) * t;
      this.engine.offsetX = startX + (targetX - startX) * t;
      this.engine.offsetY = startY + (targetY - startY) * t;

      this.engine.draw?.();

      if (progress < 1) {
        this._zoomRaf = requestAnimationFrame(animate);
      } else {
        this._zoomRaf = null;
      }
    };

    this._zoomRaf = requestAnimationFrame(animate);
    return true;
  }
  buildLocationFromSelectedQuery() {
    const q = this.selectedQuery;
    if (!q) return null;
    if (
      q.points &&
      typeof q.points.x === "number" &&
      typeof q.points.y === "number"
    ) {
      const r = 50;
      const { x, y } = q.points;
      return [
        [x - r, y - r],
        [x + r, y - r],
        [x + r, y + r],
        [x - r, y + r],
      ];
    }

    return null;
  }
  focusSelectedQuery(duration = 500) {
    const location = this.buildLocationFromSelectedQuery();
    if (!location) return false;
    this.smoothZoomToViolation({ location }, duration);
    return true;
  }
}
